import { PropsWithChildren } from 'react'

import { useApplication } from '../application'
import { AuthContext } from './useAuthorization'

const AuthProvider = ({ children }: PropsWithChildren) => {
  const { authorization, setAuthorization } = useApplication()

  return (
    <AuthContext.Provider value={{ authorization, setAuthorization }}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
